import React, { useEffect, useState } from "react";
import { Color, globalStyle } from "../assets";
import {isMobile} from "../utils/commonMethods";
import MobileEmailBottomSheet from "../screens/Profile/childComponents/MobileEmailBottomSheet";
import CommonModal from "./commonModal";
import {mobilesignInReact} from "../screens/Login/childComponents/googleSignIn";
import {getUser, setProfileEmpty} from "../screens/Profile/redux/profile.action";
import {useDispatch} from "react-redux";
import ShowError from "../common/ShowError";
import Colors from "../assets/Color/Colors";
import {globalConst} from "../utils/globalConstant";

const ForceCatchEmail = ({mobileEmailSheet, setMobileEmailSheet}) => {
    const dispatch = useDispatch();
    const [error, setError] = useState(null);

    const signInWeb = async response => {
        await mobilesignInReact(response, profileSet, null, errorMsg);
        await dispatch(getUser());
    };

    const profileSet = data => {
        dispatch(setProfileEmpty(data));
        setMobileEmailSheet(null);
    };

    const errorMsg = data => {
        setError({
            val: "Retry",
            message: data,
            errorClass: { color: Colors.red },
            borderColor: Colors.red
        });
        setTimeout(() => {
            setError(null);
        }, 2500);
    };


    return (
        <>
            <CommonModal
                onModalCallBack={() => {
                    // setMobileEmailSheet(null);
                }}
                showModal={mobileEmailSheet ? true : false}
                persistent={true}
                customModalStyle={[
                    isMobile()
                        ? {...globalStyle.modalView, alignItems: 'stretch'}
                        : {
                            ...globalStyle.modalStyleCenter,
                            width: 450,
                            alignItems: 'stretch',
                            padding: 0,
                        },
                ]}>
                <MobileEmailBottomSheet
                    setMobileEmailSheet={setMobileEmailSheet}
                    mobileEmailSheet={mobileEmailSheet}
                    responseGoogleSuccess={signInWeb}
                    forceEmail={true}
                />
                {error !== null && error?.message !== "" && (
                    <ShowError error={error} customStyle={globalConst?.isWeb ?
                        {marginTop: -15, marginBottom: 15, paddingHorizontal: 16}
                        : {marginTop: -28, marginBottom: 20, paddingHorizontal: 16}}
                    />
                )}
            </CommonModal>
        </>
    );
};

export default ForceCatchEmail;
